export default [
  {
    path: 'aprobaciones/:view',
    name: 'approval-trays',
    meta: { permiso: 'ED054', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/vistas/Trays')
  },
  {
    path: 'procesos-aprobaciones/:view',
    name: 'approval-massive',
    meta: { permiso: 'ED149', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/vistas/TraysMassive')
  },
  {
    path: 'dashboard/aprobaciones',
    name: 'approval-dashboard',
    meta: { permiso: 'ED076', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/vistas/dashboard/ApprovalsDashboard')
  },
  {
    path: 'administrar-documento/:fileId/:flowId',
    name: 'manage-file-tray',
    meta: { permiso: 'ED053', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/components/trays/FileManagement')
  },
  {
    path: 'administrar-documento-pre-entrada/:fileId/:flowId',
    name: 'manage-file-pre-tray',
    meta: { permiso: 'ED065', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/components/trays/FileManagementPreOffice')
  },
  {
    path: 'aprobaciones/expedientes/:view',
    name: 'approval-files',
    meta: { permiso: '*', requiereLogin: true }, // TODO: SET PERMISSION
    component: () => import('@/febos/chile/approvals/vistas/ApprovalFiles')
  },
  {
    path: 'aprobaciones-suplencias',
    name: 'approval-substitutions',
    meta: { permiso: 'ED103', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/components/substitutions/Substitutions')
  },
  {
    path: 'aprobaciones-plantillas/:view?/:id?',
    name: 'approval-templates',
    meta: { permiso: 'ED123', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/vistas/Templates')
  },
  {
    path: 'flujos/:wizard',
    name: 'new-flow',
    meta: { permiso: '*', requiereLogin: true }, // TODO SET PERMISSION
    component: () => import('@/febos/chile/approvals/wizardFlow/FileWizard')
  },
  {
    path: 'aprobaciones-movil/:view',
    name: 'mobile-trays',
    meta: { permiso: 'ED054', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/mobile/TraysMobile')
  },
  {
    path: 'proceso/:fileId/:flowId',
    name: 'mobile-manage',
    meta: { permiso: 'ED054', requiereLogin: true },
    component: () => import('@/febos/chile/approvals/mobile/ManageFlowMobile')
  },
  {
    path: 'firma-persona/:token',
    name: 'signature-person',
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/chile/approvals/vistas/SignaturePerson')
  },
  {
    path: 'firma-externo/:token',
    name: 'signature-external',
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/global/usuario/components/sign/advanced/eSign/AvanzadaSignEsign7External')
  },
  {
    path: 'completitud-externo/:token',
    name: 'completion-external',
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/chile/approvals/vistas/CompletitudExterno')
  },
  {
    path: 'firma-externo/validacion/:token',
    name: 'signature-external-validation',
    query: { idProceso: '', status: '' },
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/global/usuario/components/sign/advanced/eSign/EsignExternalProcess')
  },
  {
    path: 'firma-externo/validacion-signapi/:token',
    name: 'signature-external-validation-signapi',
    query: { idProceso: '' },
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/global/usuario/components/sign/advanced/signApi/SignApiExternalProcess')
  },
  {
    path: 'documento-firma-externo/:token/ok',
    name: 'signature-external-file',
    query: { idProceso: '' },
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false },
    component: () => import('@/febos/chile/approvals/vistas/SignatureExternal')
  },
];
